import { ClientItem } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import { SmartPillData, SmartPillLogDataUpdater } from 'owa-smart-pill';

/**
 * Updates pills with item-level data (language, locale, InternetMessageId).
 */
export default function createItemLevelDataUpdater(item: ClientItem): SmartPillLogDataUpdater {
    return {
        updateLogData: async (pills: SmartPillData[]) => {
            if (item) {
                const language: string = item.stampedLanguage?.language;
                const locale: string = item.stampedLanguage?.locale;
                const internetMessageId: string = (item as Message).InternetMessageId;

                pills.forEach(pill => {
                    pill.logData.mainPayload.language = language;
                    pill.logData.mainPayload.locale = locale;
                    pill.logData.cosmosOnlyData = internetMessageId;
                });
            }
        },
        getName: () => {
            return 'ItemLevelDataUpdater';
        },
    };
}
